// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"44":"6c8981e12d57b8b4ff3a","210":"a1288604abb734c02c6b"}[chunkId] + ".bundle.js";
};